/* eslint-disable no-unused-vars */
import PropertyStatus from 'scripts/constants/PropertyStatus';

const PropetyFlag = ({ propertyCode, propertyStatus }) => {
  return (
    <div>
      {propertyStatus === PropertyStatus.COMING_SOON && (
        <div className="flag coming-soon-flag">
          COMING<div>SOON</div>
          <div className="triangles-box">
            <span className="lx-triangle" />
            <span className="rx-triangle" />
          </div>
        </div>
      )}
      {propertyStatus === PropertyStatus.PRE_ORDER && (
        <div className="flag pre-order-flag">
          PRE<div>ORDER</div>
          <div className="triangles-box">
            <span className="lx-triangle" />
            <span className="rx-triangle" />
          </div>
        </div>
      )}
      {propertyStatus === PropertyStatus.NEW && (
        <div className="flag new-property-flag">
          <div>NEW</div>
          <div className="triangles-box">
            <span className="lx-triangle" />
            <span className="rx-triangle" />
          </div>
        </div>
      )}
      {propertyStatus === PropertyStatus.MARKET_CLOSED && (
        <div className="flag new-property-flag">
          MARKET <br />
          CLOSED
          <div className="triangles-box">
            <span className="lx-triangle" />
            <span className="rx-triangle" />
          </div>
        </div>
      )}
      {propertyStatus === PropertyStatus.VOTE_OPEN && (
        <div className="flag new-property-flag">
          VOTE <br />
          OPEN
          <div className="triangles-box">
            <span className="lx-triangle" />
            <span className="rx-triangle" />
          </div>
        </div>
      )}
      {propertyStatus === PropertyStatus.VOTE_CLOSED && (
        <div className="flag new-property-flag">
          ON SALE
          <div className="triangles-box">
            <span className="lx-triangle" />
            <span className="rx-triangle" />
          </div>
        </div>
      )}
    </div>
  );
};

export default PropetyFlag;
